import { createClient } from '@supabase/supabase-js';
import { takePortalTokens } from './portal';

// Auth client — points to the centralized auth Supabase project
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// The session the portal launched us with. Taken off the URL before the client exists, so
// detectSessionInUrl (still needed for the password-reset link) never sees it; AuthContext applies it.
export const portalTokens = takePortalTokens();

// Default storage key, deliberately: it is the key the portal uses for the same project, so on
// geostack.com both apps read and refresh one session. Sign in once, sign out once.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
  },
});

// The key this app used before it shared the portal's session; nothing reads it any more.
try { window.localStorage.removeItem('ultimategis.auth.token'); } catch { /* storage blocked */ }

// Data client — points to the data/storage Supabase project (for file uploads)
const dataUrl = process.env.REACT_APP_SUPABASE_DATA_URL;
const dataKey = process.env.REACT_APP_SUPABASE_DATA_KEY;

export const supabaseData = dataUrl && dataKey
  ? createClient(dataUrl, dataKey, { auth: { persistSession: false } })
  : supabase; // Fallback to auth client if data project not configured
